var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-page-header-wrapper"},[_c('div',{staticClass:"poster-wrapper"},[_c('img',{attrs:{"src":require("../../../assets/images/home-header-poster.png"),"alt":"","srcset":""}}),_c('div',{staticClass:"search-wrapper"})])])
}]

export { render, staticRenderFns }